// What the integrations API says when it refuses a request, as lines to show.
//
// The controller answers in three shapes: credential checks fail with
// `{ valid: false, message }` (400/401/500), a failed save with `{ errors }`
// (create: an array of full messages; update: a hash of attribute => messages),
// and the store/integration lookups and the admin check with `{ error }`.
// Reading only `message` (as the old screens did) left every 422 showing the
// generic fallback.
//
// Kept local to this page on purpose: src/utils/apiErrorReasons.js is being
// changed on another branch (it is only imported here, never edited).
//
// The drawer's calls are silent (no global toast), so a known `reason` has to
// be translated here or its copy is lost: it wins over the English text.

import { getApiErrorReasonMessage } from "../../utils/apiErrorReasons";

const humanize = (attr) => {
  const words = String(attr).replace(/[_.]+/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

const asLines = (value) => {
  if (value === null || value === undefined) return [];
  if (typeof value === "string") return value.trim() ? [value.trim()] : [];
  if (Array.isArray(value)) return value.flatMap(asLines);
  if (typeof value === "object") {
    return Object.entries(value).flatMap(([attr, messages]) =>
      asLines(messages).map((msg) => (attr === "base" ? msg : `${humanize(attr)} ${msg}`)),
    );
  }
  return [String(value)];
};

export function integrationErrorLines(error, fallback, t) {
  const data = error?.response?.data;
  const reasonMessage =
    t && data && typeof data === "object" ? getApiErrorReasonMessage(data, t) : null;
  if (reasonMessage) return [reasonMessage];
  const lines = [
    ...asLines(data?.message),
    ...asLines(data?.errors),
    ...(data?.message || data?.errors ? [] : asLines(data?.error)),
  ];
  return lines.length ? lines : [fallback];
}
